import Link from 'next/link';
import { FC, ReactNode } from 'react';

import styles from './tag.module.scss';

interface TagProps {
  link?: string;
  children?: ReactNode;
}

const Tag: FC<TagProps> = (props) => {
  const { link, children } = props;

  const tagClassName = styles.container;

  if (link) {
    return (
      <Link href={link} className={tagClassName} legacyBehavior>
        <span>{children}</span>
      </Link>
    );
  }

  return <span className={tagClassName}>{children}</span>;
};

export default Tag;
